import { render, staticRenderFns } from "./goods_analysis.vue?vue&type=template&id=2a922d97&scoped=true"
import script from "./goods_analysis.vue?vue&type=script&lang=js"
export * from "./goods_analysis.vue?vue&type=script&lang=js"
import style0 from "./goods_analysis.vue?vue&type=style&index=0&id=2a922d97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a922d97",
  null
  
)

export default component.exports